import React from "react"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { GatsbyImage } from "gatsby-plugin-image"
import { gtmTracking } from "@/utils/gtm-tracking"
import bgGreen from "@/images/customer-stories/bg-green.png"

const CustomerStorySnapshot = ({
  name,
  title,
  companyName,
  quote,
  text,
  link,
  backgroundImage,
  image,
  svg: SvgComponent,
  imageHeight = 300,
  imageWidth = 300,
  alt,
  children,
}) => {
  const { t } = useTranslation()
  const predictedLogoAlt = companyName
    ? `${companyName} logo`
    : name
      ? `${name} logo`
      : ""
  const overlayAlt = alt || (image ? name : predictedLogoAlt) || ""

  const content = (
    <>
      <div className="customer-story-snapshot__container col-sm-6 col-md-7">
        <div className="customer-story-snapshot__card">
          {quote && (
            <p className="customer-story-snapshot__card-description">
              "{quote}"
            </p>
          )}
          {text && (
            <p className="customer-story-snapshot__card-description">{text}</p>
          )}
          {name && <p className="mb-0 h4">{name}</p>}
          {title && <p className={companyName ? "mb-0" : undefined}>{title}</p>}
          {companyName && <p>{companyName}</p>}
          {children}
        </div>
        <div className="p--lg customer-story-snapshot__card-link">
          {t("customer-story-snapshot.read-story")}
          <img
            src="/icons/arrow-right.svg"
            className="customer-story-snapshot__arrow"
            alt=""
            width="32"
            height="32"
          />
        </div>
      </div>
      <div className="customer-story-snapshot__image-wrapper col-sm-6 col-md-5">
        {backgroundImage ? (
          <GatsbyImage
            image={backgroundImage}
            alt=""
            role="presentation"
            className="customer-story-snapshot__image--background"
            height={500}
            width={500}
          />
        ) : (
          <div className="customer-story-snapshot__image--background">
            <img src={bgGreen} alt="" role="presentation" />
          </div>
        )}

        {image ? (
          <GatsbyImage
            image={image}
            alt={overlayAlt}
            className="customer-story-snapshot__image--overlay"
            height={imageHeight}
            width={imageWidth}
          />
        ) : SvgComponent ? (
          <SvgComponent
            className="customer-story-snapshot__image--overlay customer-story-snapshot__image--overlay--svg"
            height={imageHeight}
            width={imageWidth}
            alt={overlayAlt}
            role="img"
            aria-label={overlayAlt || undefined}
          />
        ) : null}
      </div>
    </>
  )

  const className = "customer-story-snapshot container-fluid"

  if (!link) {
    return <div className={className}>{content}</div>
  }

  return (
    <Link
      to={link}
      className={className}
      onClick={gtmTracking("Link Click", name, "Customer Story Snapshot")}
    >
      {content}
    </Link>
  )
}

export default CustomerStorySnapshot
